import React from 'react';
import { Card, CardContent } from './ui/card';
import { Quote } from 'lucide-react';
import { testimonials } from '../mockData';

const Testimonials = () => {
  return (
    <section className="py-32 bg-gradient-to-b from-black to-[#0a0a0a] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-[#C9A55A]/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-[#C9A55A]/20 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        <div className="text-center mb-20">
          <div className="inline-block">
            <div className="flex items-center justify-center w-16 h-16 bg-[#C9A55A]/10 rounded-full mb-6 border border-[#C9A55A]/20">
              <Quote className="text-[#C9A55A]" size={32} />
            </div>
          </div>
          <h2 className="luxury-heading text-5xl md:text-6xl text-white mb-6">
            Client Testimonials
          </h2>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto leading-relaxed">
            Trusted by leaders across industries
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="luxury-card bg-gradient-to-br from-white/5 to-white/[0.02] border-white/10 hover:border-[#C9A55A]/30">
              <CardContent className="p-8">
                <Quote className="text-[#C9A55A] mb-6" size={36} />
                <p className="text-gray-300 leading-relaxed mb-8 italic">
                  "{testimonial.content}"
                </p>
                <div className="flex items-center space-x-4 pt-6 border-t border-white/10">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="w-14 h-14 rounded-full object-cover border-2 border-[#C9A55A]/20"
                  />
                  <div>
                    <div className="text-white font-semibold">{testimonial.name}</div>
                    <div className="text-gray-500 text-sm">{testimonial.role}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;